import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials so the httpOnly session_token cookie is sent for the Google flow.
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Shared in-flight/short-lived cache so multiple dashboard cards reuse one /holdings/summary call.
let _summaryCache = { at: 0, promise: null };
const SUMMARY_LS_KEY = "dp_holdings_summary";
let _summaryOwner = null;
export const setSummaryCacheOwner = (uid) => { _summaryOwner = uid || null; };
export const clearSavedHoldingsSummary = () => {
  _summaryCache = { at: 0, promise: null };
  try { localStorage.removeItem(SUMMARY_LS_KEY); } catch {}
};
// Last saved summary for the signed-in user (stale-while-revalidate seed).
export const readSavedHoldingsSummary = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(SUMMARY_LS_KEY) || "null");
    return raw && _summaryOwner && raw.uid === _summaryOwner ? raw.data : null;
  } catch { return null; }
};
export const getHoldingsSummary = (force = false) => {
  if (!force && _summaryCache.promise && Date.now() - _summaryCache.at < 30000) return _summaryCache.promise;
  const promise = api.get("/holdings/summary").then((r) => {
    try {
      if (_summaryOwner) localStorage.setItem(SUMMARY_LS_KEY, JSON.stringify({ uid: _summaryOwner, data: r.data }));
    } catch {}
    return r;
  }).catch((e) => {
    _summaryCache = { at: 0, promise: null };
    throw e;
  });
  _summaryCache = { at: Date.now(), promise };
  return promise;
};

export default api;
